<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div style="height: 35px; width: 90%;margin: 20px auto">
      <span style="color: #8e8e8e;float: left;font-family: '黑体';font-size: 15px">住户余额：</span><span style="float: right;">
            <span style="color:#333;font-size: 12px">￥</span><span style="font-size: 24px;">{{content.balance}}</span>
          </span>
      <div class="clear" style="clear: both"></div>
      <div>
        <p style="font-family: '黑体';font-weight: bold">选择充值金额：</p>
        <van-button type="default" style="width:120px;height: 70px;margin-left: 10%;border-radius: 10px" v-model="price" :loading="false" @click="submitMoney(50)">
          50元
        </van-button>
<!--        <van-button type="default" style="width:120px;height: 70px;margin-left: 10%;border-radius: 10px" v-model="price" :loading="false" @click="submitMoney(0.01)">-->
<!--          0.01元-->
<!--        </van-button>-->
        <van-button type="default" style="width:120px;margin-left: 10%;height: 70px;border-radius: 10px" v-model="price" :loading="false" @click="submitMoney(100)">
          100元
        </van-button>
        <van-button type="default" :loading="false" v-model="price"  style="width:120px;margin-left: 10%;height: 70px;border-radius: 10px" @click="submitMoney(200)">
          200元
        </van-button>
        <van-button type="default" style="width:120px;margin-left: 10%;height: 70px;border-radius: 10px" v-model="price"  :loading="false" @click="submitMoney(300)">
          300元
        </van-button>
      </div>
    </div>

  </div>
</template>

<script>
import {orderAll} from "../common/api/mentw";
import wx from "weixin-js-sdk";
import jump from "../common/jump";
import {wxPay} from "../common/api/elall";

export default {
  name: "rechargeBalance",
  data(){
    return {
      balance:null,
      content:[],
      price:100
    }
  },
  mounted() {
    if(this.$route.query.orderNo!= undefined){
      this.$toast.success("充值成功")
    }
    this.content = this.$route.query
  },
  methods:{
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    submitMoney(price){
      this.content["price"] = price
      this.content["payType"] = 1
      this.content["type"] = 2
      orderAll(this.content).then(res => {
        this.jsap(res.data.orderNo,1,res.data.payType,res.data.partnerCode,res.data.storeId)
      })
    },
    jsap(orderNo,devType,payType,partnerCode,storeId){
      this.typ = window.__wxjs_environment
      var isWxMini = window.__wxjs_environment === 'miniprogram'     // 判断场景是否小程序
      if (payType == 10) {//使用跳转到其他小程序/pages/logs/logs路径付款的方式
        if (isWxMini) {
          const url = '/pages/extPay/index?orderNo=' + orderNo + '&token=' + this.$cookies.get("token") + '&devType=' + devType + '&partnerCode=' + partnerCode + '&storeId=' + storeId
          this.typ = "11跳转"
          wx.miniProgram.navigateTo({
            url: url
          });
        } else if (/MicroMessenger/i.test(navigator.userAgent)) {
          // 判断是否是公众号
          this.wxPay_h5(orderNo)
        } else {
          this.$toast('请在微信端重新操作')
        }
      }
    },

    wxPay_h5(orderNo) {
      wxPay(orderNo).then((reson) => {
        console.log("支付参数:", reson);
        let {subAppId, appId, nonceStr, paySign, signType, timeStamp} = reson.data;
        // console.log("支付参数:", payData);
        function onBridgeReady() {
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId": subAppId || appId,     //公众号ID，由商户传入
                "timeStamp": timeStamp,         //时间戳，自1970年以来的秒数
                "nonceStr": nonceStr, //随机串
                "package": reson.data.package,
                "signType": signType,         //微信签名方式：
                "paySign": paySign //微信签名
              },
              function (res) {
                console.log(res, "wxpay_res");
                // if(res.err_msg == "get_brand_wcpay_request:ok" ){
                //   // 使用以上方式判断前端返回,微信团队郑重提示：
                //   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                // }
                if (res.err_msg == "get_brand_wcpay_request:ok") { //支付成功点击完成跳转页面
                  WeixinJSBridge.invoke('closeWindow', {}, function (res) {
                  });
                }
                if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  this.$toast.success("您已取消支付");

                }
                if (res.err_msg == "get_brand_wcpay_request:fail") {
                  this.$toast.success("支付失败");
                }
              }
          );
        }
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        }else{
          onBridgeReady();
        }
      }).catch((error) => {
        console.error("获取支付参数失败:", error);
        this.$toast.fail("获取支付信息失败");
      });
    },
  }
}
</script>

<style scoped>

</style>